import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './NavBar.css';
import logoImg from '../assets/logo.jpeg';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

// 1. IMPORTĂ POZA LOCALĂ
import defaultAvatar from '../assets/149071.png';

const NavBar = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    // 🔒 ADMIN EMAIL CONSTANT
    const ADMIN_EMAIL = "hadade.cosmin@yahoo.com";

    // (Am șters constanta veche cu link-ul de pe internet pentru a folosi importul de sus)

    const closeMenu = () => setIsOpen(false);
    const toggleMenu = () => setIsOpen(!isOpen);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            closeMenu();
            navigate('/');
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };

    const getUserName = () => {
        if (user && user.displayName) return user.displayName;
        if (user && user.email) return user.email.split('@')[0];
        return "Contul Meu";
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMenu}>
                    <img src={logoImg} alt="FitnessPro Logo" className="logo-image" />
                </Link>

                <div className="menu-icon" onClick={toggleMenu}>
                    {isOpen ? '✕' : '☰'}
                </div>

                <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
                    {/* --- STANDARD LINKS --- */}
                    <li className="nav-item"><NavLink to="/" className="nav-links" onClick={closeMenu}>Home</NavLink></li>
                    <li className="nav-item"><NavLink to="/about" className="nav-links" onClick={closeMenu}>Despre mine</NavLink></li>
                    <li className="nav-item"><NavLink to="/plans" className="nav-links" onClick={closeMenu}>Abonamente</NavLink></li>
                    <li className="nav-item"><NavLink to="/articles" className="nav-links" onClick={closeMenu}>Articole</NavLink></li>
                    <li className="nav-item"><NavLink to="/testimonials" className="nav-links" onClick={closeMenu}>Testimoniale</NavLink></li>
                    <li className="nav-item"><NavLink to="/train-travel" className="nav-links" onClick={closeMenu}>Train & Travel</NavLink></li>

                    {/* --- ADMIN BUTTON (VISIBLE ONLY TO ADMIN) --- */}
                    {user && user.email === ADMIN_EMAIL && (
                        <li className="nav-item">
                            <NavLink
                                to="/admin"
                                className="nav-links"
                                onClick={closeMenu}
                                style={{ color: '#ccff00', fontWeight: 'bold' }}
                            >
                                Admin Panel
                            </NavLink>
                        </li>
                    )}

                    {/* --- MOBILE ONLY: Profil cu Poză --- */}
                    {user && (
                        <li className="nav-item-mobile">
                            <NavLink to="/profile" className="nav-links mobile-profile-link" onClick={closeMenu} style={{color: '#0ff'}}>
                                {/* 2. UPDATE POZA MOBIL + onError */}
                                <img
                                    src={user.photoURL || defaultAvatar}
                                    alt="User"
                                    className="nav-profile-img-mobile"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultAvatar;
                                    }}
                                />
                                {getUserName()}
                            </NavLink>
                        </li>
                    )}

                    <li className="nav-item-mobile">
                        {user ? (
                            <span className="btn-mobile" onClick={handleLogout}>Sign Out</span>
                        ) : (
                            <Link to="/signin" className="btn-mobile" onClick={closeMenu}>Sign In</Link>
                        )}
                    </li>
                </ul>

                {/* --- DESKTOP ONLY: Profile Dropdown --- */}
                {user ? (
                    <div className="profile-container">
                        <div className="profile-trigger">
                            {/* 3. UPDATE POZA DESKTOP + onError */}
                            <img
                                src={user.photoURL || defaultAvatar}
                                alt="Profile"
                                className="nav-profile-img"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defaultAvatar;
                                }}
                            />
                            <span className="profile-name">
                                {getUserName()} <i className="fas fa-caret-down"></i>
                            </span>
                        </div>

                        <div className="profile-dropdown">
                            <Link to="/profile" className="dropdown-item">Profilul Meu</Link>

                            {/* Optional: Add Admin Link inside dropdown too */}
                            {user.email === ADMIN_EMAIL && (
                                <Link to="/admin" className="dropdown-item" style={{color: '#ccff00'}}>Admin Panel</Link>
                            )}

                            <button className="dropdown-btn" onClick={handleLogout}>Sign Out</button>
                        </div>
                    </div>
                ) : (
                    <Link to="/signin" className="btn-desktop">Sign In</Link>
                )}
            </div>
        </nav>
    );
};

export default NavBar;